import { MSUserInfo } from "../models";
import { find } from "lodash";

export function isUserAssignedToEntity(
  entityData: any,
  email: string,
): boolean {
  if (
    entityData?.owner &&
    entityData?.owner?.userPrincipalName &&
    (entityData.owner as MSUserInfo).userPrincipalName.toLowerCase() ===
      email.toLowerCase()
  ) {
    return true;
  }

  if (
    find(entityData?.deputies || [], (user: MSUserInfo) => {
      return (
        user?.userPrincipalName &&
        user.userPrincipalName.toLowerCase() === (email || "").toLowerCase()
      );
    })
  ) {
    return true;
  }
  return false;
}
